// ** Navigation imports
import apps from './apps'

import charts from './charts'
import dashboards from './dashboards'
import processmaps from './processmaps'

import uiElements from './ui-elements'

// ** Merge & Export
export default [...processmaps, ...dashboards, ...apps, ...charts, ...uiElements]
